import React, {useEffect, useState} from 'react';
import {Select} from "antd";


import {FcmTopic} from "types";
import {getAllTopics} from "../../services/campaigns";


const FcmTopicsSelect: React.FC<any> = (props: any) => {
    const [data, setData] = useState<FcmTopic[]>([])
    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        fetchData()
    }, [])

    const fetchData = () => {
        setLoading(true)
        getAllTopics()
            .then(res => {
                let response = res?.data?.fcmTopics || []
                response = response?.map((item: FcmTopic, index: number) => ({
                    key: `topic-${index}`,
                    ...item
                }))
                if (response) {
                    setData((response))
                }
                // todo: delete
                // setData(DEFAULT_TOPICS)
            })
            .catch(err => {
                console.error(err)
            })
            .finally(() => {
                setLoading(false)
            })
    }
    const options = data?.map((item: FcmTopic) => ({
        label: `${item.topicName} (${item.usersCount})`,
        value: item.topicName
    }))
    return <>
        <Select loading={loading} options={options} allowClear mode="multiple" {...props}/>
    </>
}

export default FcmTopicsSelect